var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Spinner", { attrs: { "is-loading": _vm.isDocumentsLoading } }),
      !_vm.isDocumentsLoading
        ? _c(
            "div",
            { attrs: { id: `${_vm.type}-documents` } },
            [
              _c("p", [
                _vm._v("Seleccione los documentos que comprueben la "),
                _c("span", { staticClass: "is-lowercase" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
                _vm._v(":"),
              ]),
              _vm.uploadedDocuments.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.uploadedDocuments, function (report, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "separator",
                          attrs: { "data-cy": "uploaded-documents" },
                        },
                        [_vm._v(" " + _vm._s(report.pdfFileName) + " ")]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c(
                "b-button",
                {
                  staticClass: "add",
                  attrs: {
                    size: "is-small",
                    icon: "plus",
                    type: "mr-4 mb-1 mt-4",
                    "icon-left": "plus",
                    rounded: "",
                  },
                  on: { click: _vm.selectDocument },
                },
                [_vm._v(" Subir nuevo documento ")]
              ),
              _c("input", {
                ref: "fileInput",
                attrs: { type: "file", accept: "application/pdf", hidden: "" },
                on: { change: _vm.handleFileUpload },
              }),
              _vm.validateDocuments && _vm.uploadedDocuments.length === 0
                ? _c(
                    "p",
                    {
                      staticClass: "help is-danger",
                      attrs: { "data-cy": "error-message" },
                    },
                    [
                      _vm._v(
                        " Se requiere subir al menos un archivo para comprobar la información registrada. "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }